var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHairdryer = function SvgHairdryer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 7.75h.5m-.5 3h.5m8.436 1.07.945 6.567a1 1 0 0 0 .99.863h1.629a1 1 0 0 0 1-1V11.5m-2.5-6.705v7.41m.09-7.427L7.75 6.284v4.432l8.09 1.506c1.803.245 3.41-1.135 3.41-2.927v-1.59c0-1.792-1.607-3.172-3.41-2.927Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHairdryer;